import React from 'react';
import { IconProps } from './types';

const Plus4: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 5C12.6104 5 13.1053 5.49484 13.1053 6.10526V10.8947L17.8947 10.8947C18.5052 10.8947 19 11.3896 19 12C19 12.6104 18.5052 13.1053 17.8947 13.1053H13.1053V17.8947C13.1053 18.5052 12.6104 19 12 19C11.3896 19 10.8947 18.5052 10.8947 17.8947V13.1053H6.10526C5.49484 13.1053 5 12.6104 5 12C5 11.3896 5.49484 10.8947 6.10526 10.8947H10.8947V6.10526C10.8947 5.49484 11.3896 5 12 5Z"
      fill={!ignoreColor ? color : undefined}
    />
  </svg>
);

export default Plus4;
